<template>
<!-- old primary #329331 -->
  <v-footer app absolute padless max-width="450px"  height="60px"
    style="box-sizing: border-box; background-color: #329331;"
    class="footer-buttons justify-space-around"
  >
    <div v-for="link in filteredLinks" :key="link.name" 
      :style="borderStyle(link)"
      class="mx-2 flex-grow-1 py-2"
    >
      <router-link
        :to="{ name: link.name }"
        :active="currentPath(link)"
        class="d-flex flex-column align-center justify-center text-decoration-none"
      >
        <v-icon :color="link.color || 'white'">{{ link.icon }}</v-icon>
        <div :style="{ 'font-size': '10px', 'color': link.color || 'white',  'line-height':' 10px' }">
          {{ link.label }}
        </div>
      </router-link>

      <!-- <router-link v-else 
        :to="{ name: link.name }"
        :active="currentPath(link)"
        class="d-flex flex-column align-center justify-center text-decoration-none white--text"
      >
        <v-icon color="white">{{ link.icon }}</v-icon>
        <div style="font-size: 10px; line-height: 10px;">{{ link.label }}</div>
      </router-link> -->

    </div>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "NavFooter",

  data: () => ({
    links: [
      { label: 'Refer', name: 'referrals', path: '/referrals', icon: 'mdi-account-multiple-outline'},
      { label: 'Badges', name: 'badges', path: '/badges', icon: 'mdi-seal', color: '#004056'},
      { label: 'Rewards', name: 'rewards', path: '/rewards', icon: 'mdi-currency-usd', color: '#F7C050'},
      { label: 'Leads', name: 'leads/list', path: '/leads', icon: 'mdi-account-filter-outline'},
      { label: 'Pros', name: 'pros/list', path: '/pros', icon: 'mdi-handshake-outline', requiresAdmin: true },
      { label: 'You', name: 'you', path: '/you', icon: 'mdi-account-box-outline'},
    ],
  }),

  computed: {
    ...mapGetters('auth', ['userIsAdmin']),

    filteredLinks() {
      return this.links.filter( link => this.userIsAdmin || !link.requiresAdmin)
    },
  },

  methods: {
    borderStyle(link) {
      let color = this.$route.matched.some( r => r.path == link.path ) ? link.color || 'white' : '#00000000'

      return { 
        'border-bottom': `3px solid ${ color }` 
      }
    },

    currentPath(link) { 
      return this.$route.matched.some( r => r.path == link.path )
    },
  }
}
</script>

<style lang="scss" scoped>

.footer-buttons {
  border-top: 1px solid grey !important;
}

</style>